export const APP_BUSY_DECREMENT = 'APP_BUSY_DECREMENT'
export const APP_BUSY_INCREMENT = 'APP_BUSY_INCREMENT'
export const AUTH_FAILURE = 'AUTH_FAILURE'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const AUTH_REQUEST = 'AUTH_REQUEST'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const CONTENT_RECEIVE = 'CONTENT_RECEIVE'
export const CONTENT_REQUEST = 'CONTENT_REQUEST'
export const CURRENT_CLIENT_RESET = 'CURRENT_CLIENT_RESET'
export const CURRENT_CLIENT_UPDATE = 'CURRENT_CLIENT_UPDATE'
export const DISMISS_NOTIFICATION = 'DISMISS_NOTIFICATION'
export const DRAG_DROP_FILES = 'DRAG_DROP_FILES'
export const DRAG_DROP_RESET = 'DRAG_DROP_RESET'
export const DRAWER_CLOSE = 'DRAWER_CLOSE'
export const DRAWER_OPEN = 'DRAWER_OPEN'
export const ERROR_NOTIFICATION = 'ERROR_NOTIFICATION'
export const INFO_NOTIFICATION = 'INFO_NOTIFICATION'
export const MESSAGE_CREATE = 'MESSAGE_CREATE'
export const OFFER_CREATE = 'OFFER_CREATE'
export const PAGE_MODE_CHANGE = 'PAGE_MODE_CHANGE'
export const SILO_SETTINGS = 'SILO_SETTINGS'
export const SUCCESS_NOTIFICATION = 'SUCCESS_NOTIFICATION'
export const WARNING_NOTIFICATION = 'WARNING_NOTIFICATION'
export const WORKSPACE_SELECTED = 'WORKSPACE_SELECTED'



// WEBPACK FOOTER //
// src/actions/index.js